import { Helmet } from "react-helmet-async";

const SITE = "https://clearhorizon-consulting.com";

export const Seo = ({ title, description, path = "/" }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE}${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${SITE}${path}`} />
  </Helmet>
);
